import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import useTitle from "hooks/TitleManager";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import ApiDatabase from "server";

const PdfView = () => {
  useTitle({ title: "Ouverture fichier" });

  const [searchParams] = useSearchParams();
  const type = searchParams.get("type");
  const idCompany = searchParams.get("idCompany");
  const fileName = searchParams.get("fileName") ?? "";
  const [docs, setDocs] = useState([]);
  const [isWaiting, setIsWaiting] = useState(true);

  useEffect(() => {
    if (type && idCompany) {
      manageFiles();
    }
  }, [type, idCompany, fileName]);

  const manageFiles = () => {
    if (!type || !idCompany) {
      setDocs([]);
      return;
    }

    setIsWaiting(true);

    ApiDatabase.postPresignFiles(
      {
        type,
        idCompany,
        fileName,
      },
      (data) => {
        const urls = Array.isArray(data?.urls) ? data.urls : [];
        const docsFromLinks = urls.filter(Boolean).map((item) => {
          const href = item.url || item.uri || "";
          let originalFileName = "";
          try {
            const u = new URL(href);
            originalFileName = decodeURIComponent(
              (u.pathname.split("/").pop() || "").trim()
            );
          } catch (e) {
            const clean = href.split("?")[0].split("#")[0];
            originalFileName = decodeURIComponent(
              (clean.split("/").pop() || "").trim()
            );
          }
          return {
            uri: href,
            fileName: originalFileName || "document",
            fileType: item.type || "application/pdf",
          };
        });
        setIsWaiting(false);
        setDocs(docsFromLinks);
      },
      (err) => {
        console.log(err);
        setDocs([]);
        setIsWaiting(false);
      }
    );
  };

  return (
    <div className="h-screen">
      <div className="h-full overflow-auto">
        {isWaiting ? (
          <div className="flex flex-col shadow border rounded-md p-6 animate-pulse space-y-6">
            <div className="flex items-center space-x-4">
              <div className="h-20 w-20 bg-gray-200 rounded"></div>
              <div className="flex-1 space-y-3">
                <div className="h-5 w-1/3 bg-gray-200 rounded"></div>
                <div className="h-4 w-1/4 bg-gray-200 rounded"></div>
              </div>
            </div>

            <div className="space-y-2">
              <div className="h-4 w-1/5 bg-gray-200 rounded"></div>
              <div className="h-3 w-2/3 bg-gray-200 rounded"></div>
              <div className="h-3 w-3/4 bg-gray-200 rounded"></div>
              <div className="h-3 w-1/2 bg-gray-200 rounded"></div>
            </div>

            <div className="space-y-2">
              <div className="h-4 w-1/4 bg-gray-200 rounded"></div>
              <div className="h-3 w-2/3 bg-gray-200 rounded"></div>
              <div className="h-3 w-3/4 bg-gray-200 rounded"></div>
              <div className="h-3 w-1/2 bg-gray-200 rounded"></div>
            </div>

            <div className="space-y-2">
              <div className="h-4 w-1/4 bg-gray-200 rounded"></div>
              <div className="h-3 w-2/3 bg-gray-200 rounded"></div>
              <div className="h-3 w-3/4 bg-gray-200 rounded"></div>
              <div className="h-3 w-1/2 bg-gray-200 rounded"></div>
            </div>

            <div className="space-y-2">
              <div className="h-4 w-1/4 bg-gray-200 rounded"></div>
              <div className="h-3 w-2/3 bg-gray-200 rounded"></div>
              <div className="h-3 w-3/4 bg-gray-200 rounded"></div>
            </div>

            <div className="space-y-2">
              <div className="h-4 w-1/4 bg-gray-200 rounded"></div>
              <div className="grid grid-cols-2 gap-2">
                <div className="h-3 w-3/4 bg-gray-200 rounded"></div>
                <div className="h-3 w-2/3 bg-gray-200 rounded"></div>
                <div className="h-3 w-1/2 bg-gray-200 rounded"></div>
                <div className="h-3 w-2/5 bg-gray-200 rounded"></div>
              </div>
            </div>
          </div>
        ) : docs.length > 0 ? (
          <DocViewer
            style={{ minHeight: "100%", height: "100%" }}
            documents={docs}
            config={{
              pdfZoom: {
                defaultZoom: 1,
                zoomJump: 0.1,
              },
            }}
            pluginRenderers={DocViewerRenderers}
          />
        ) : (
          <div className="flex flex-col items-center justify-center h-full text-gray-500">
            <p>Aucun document disponible</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default PdfView;
